<template>
  <article class="preview-section grid relative rounded-xl overflow-hidden">
    <div
      class="bg-base-color col-start-1 row-start-1 w-full h-full"
      :style="{ backgroundColor: theme.baseColour }"
    ></div>
    <div
      v-if="theme?.backgroundImage"
      class="bg-image col-start-1 row-start-1 bg-cover w-full h-full bg-no-repeat bg-center"
      :style="{ backgroundImage: `url(${theme.backgroundImage?.large})`, opacity: theme.visibility / 100 }"
    ></div>
    <div class="color-palette col-start-1 row-start-1 w-full h-full relative">
      <ColorPalleteThumbnail
        :colors="theme.colorPalette?.colors"
        class="w-full h-full absolute"
      ></ColorPalleteThumbnail>
    </div>
    <div
      class="theme-name col-start-1
      row-start-1 font-bold relative"
    >
      <h2
        class="absolute top-12 left-12"
        :title="theme?.themeName"
        :style="{ fontFamily: theme?.fontFamily, color: theme?.textColour }"
      >
        {{ $i18nPresenter.t('Question goes here') }}
      </h2>
    </div>
    <div v-if="showLogo" class="theme-logo relative col-start-1 row-start-1">
      <img v-if="theme?.logo?.thumbnail" :src="theme?.logo?.thumbnail" class="max-w-28 max-h-5 absolute top-4 right-4">
      <div v-else class="max-w-28 absolute top-4 right-4">
        <aha-logo
          v-if="isColorLight"
          width="156"
          height="26"
          viewBox="0 0 9600 1602"
          :use-default-color="false"
          class="img-logo-white max-w-28 text-white-100"
        />
        <aha-logo
          v-else
          width="156"
          height="26"
          viewBox="0 0 9600 1602"
          class="img-logo-default max-w-28"
        />
      </div>
    </div>
  </article>
</template>
<script>
import ColorPalleteThumbnail from '@/components-v2/presentation-editor/side-right/right-nav/ColorPalleteThumbnail.vue'
import { isColorLight } from '@/utils/color.utils'

export default {
  name: 'ThemePreview',
  components: {
    ColorPalleteThumbnail,
  },
  props: {
    theme: {
      type: Object,
      default: () => {},
    },
    showLogo: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isColorLight() {
      return isColorLight(this.theme?.textColour)
    },
  },
}
</script>
<style lang="scss" scoped>
.preview-section {
  @apply border border-base-50;
  aspect-ratio: 16 / 9;

}
</style>
